module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.availableTenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.userTenants),
        expression: "userTenants"
      }],
      attrs: {
        "disabled": _vm.formReadonly,
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.userTenants) ? _vm._i(_vm.userTenants, tenant.id_key) > -1 : (_vm.userTenants)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.userTenants,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.userTenants = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.userTenants = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.userTenants = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n              ")])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-lg fa-building"
  }), _vm._v(" Unidades")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7f93874"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/Employee/Edit/EditForm.vue
// module id = 1070
// module chunks = 1